import { appendALExamTemplate } from '@/functions/idp'

import RIC from './RIC_10'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
